import React from 'react';
import { LoadingIndicator } from 'lib/components';
import { Flex } from 'lib/components/styles/layout';
import { AIAssistantCard } from './AIAssistantCard';
import {
  IUpsertCustomerAvatarParams,
  useEditCustomerAvatarMutation,
} from 'lib/api/avatars/customerAvatars/useEditCustomerAvatarMutation';
import {
  EmptySearchText,
  EmptySearchWrapper,
} from 'app/pages/admin/landing-pages-v2/styles';
import { IAIAssistantResponse } from 'lib/api/avatars/customerAvatars/useQueryCustomerAvatars';
import { useTranslation } from 'react-i18next';

interface IAIAssistantsListProps {
  aiAssistants: IAIAssistantResponse[];
  isLoading: boolean;
}

export const AIAssistantsList = ({
  aiAssistants,
  isLoading,
}: IAIAssistantsListProps) => {
  const { t } = useTranslation();
  const {
    mutateAsync: editCustomerAvatarMutation,
    isLoading: isEditingCustomerAvatarMutation,
  } = useEditCustomerAvatarMutation();

  const onEditCustomerAvatar = ({
    avatarId,
    avatarName,
    description,
    title,
    default: defaultValue,
  }: IUpsertCustomerAvatarParams) => {
    editCustomerAvatarMutation({
      avatarId,
      avatarName,
      description,
      title,
      default: defaultValue,
    });
  };

  return (
    <Flex
      width='100%'
      flexDirection='row'
      gap='27px'
      justifyContent='flex-start'
      flexWrap='wrap'
    >
      {isLoading ? (
        <div>
          <LoadingIndicator isLoading={isLoading} />
        </div>
      ) : (
        <>
          {aiAssistants.length > 0 ? (
            aiAssistants.map(aiAssistant => (
              <AIAssistantCard
                key={aiAssistant.avatarId}
                aiAssistant={aiAssistant}
                isLoading={isEditingCustomerAvatarMutation}
                onEditCustomerAvatar={onEditCustomerAvatar}
              />
            ))
          ) : (
            <EmptySearchWrapper>
              <EmptySearchText>
                {t('There are no AI Video Agents available.')}
              </EmptySearchText>
            </EmptySearchWrapper>
          )}
        </>
      )}
    </Flex>
  );
};
